var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.4185 5.47616C22.2247 5.25315 17.5726 8.69735e-05 11.4909 8.69735e-05C5.38504 -0.0246916 0.757177 5.25315 0.563339 5.47616C-0.18778 6.34341 -0.18778 7.65668 0.563339 8.52393C0.587569 8.54871 5.36081 14 11.4909 14C17.621 14 22.3943 8.57349 22.4185 8.52393C23.1938 7.65668 23.1938 6.34341 22.4185 5.47616ZM21.1585 7.35933C21.1101 7.40889 16.8699 12.2655 11.4909 12.2655C6.11193 12.2655 1.87174 7.40889 1.82328 7.35933C1.65367 7.1611 1.65367 6.83898 1.82328 6.64075C1.87174 6.56642 6.16039 1.70981 11.4909 1.70981C16.8214 1.70981 21.1101 6.56642 21.1585 6.61597C21.3524 6.83898 21.3524 7.13633 21.1585 7.35933Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.4908 3.12207C9.40701 3.12207 7.71094 4.85657 7.71094 6.98753C7.71094 9.11849 9.40701 10.853 11.4908 10.853C13.5745 10.853 15.2706 9.11849 15.2706 6.98753C15.2706 4.85657 13.5745 3.12207 11.4908 3.12207ZM11.4908 9.11849C10.352 9.11849 9.40701 8.15213 9.40701 6.98753C9.40701 5.82294 10.352 4.85657 11.4908 4.85657C12.6296 4.85657 13.5745 5.82294 13.5745 6.98753C13.5745 8.15213 12.6296 9.11849 11.4908 9.11849Z",
    fill: "black",
    fillOpacity: 0.7
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.4bc52214fe6f4e2cc8ddf4bf78a914bb.svg";
export { ForwardRef as ReactComponent };